export default (): string | undefined => {
    const sessionData = localStorage.getItem('sessionData')
    return sessionData === null ? undefined : JSON.parse(sessionData)
}
